import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const systemConfigurationRedirectRoute: InvariantJiraRoute = {
	name: 'system-configuration-general-redirect',
	path: '/secure/admin/ViewApplicationProperties.jspa',
	exact: true,
};
